import { CONFIG } from '../config/config'

const U = CONFIG.UNLOCK

export const evaluateUnlocks = ({ profile, goals, phases, reviews, current }) => {
  const now      = new Date()
  const onboarded = profile?.onboarding_completed_at ? new Date(profile.onboarding_completed_at) : null
  const days     = onboarded ? Math.floor((now - onboarded) / 86400000) : 0

  const committed    = goals.filter(g => ['committed','active','paused','completed'].includes(g.status))
  const totalGoals   = goals.filter(g => g.status !== 'draft').length
  const donePhases   = phases.filter(p => p.status === 'completed' && p.actual_weeks)
  const fresh        = []

  const check = (key, condition) => {
    if (condition && !current.has(key)) fresh.push(key)
  }

  check('task_level',           committed.length >= 2 && phases.length >= 1)
  check('priority_layer',       reviews.length >= 1)
  check('survival_filter',      reviews.length >= 1)
  check('cost_field',           committed.length >= U.COST_GOAL_COUNT)
  check('dependencies',         totalGoals >= U.DEPS_GOAL_COUNT)
  check('drift_layer',          days >= U.DRIFT_DAYS)
  check('basic_analysis',       days >= U.BASIC_ANALYSIS_DAYS && donePhases.length >= 1)
  check('full_analysis',        days >= U.FULL_ANALYSIS_DAYS  && donePhases.length >= 3)

  return fresh
}

export const phaseNeedsTaskLevel = (phase) =>
  (phase?.estimated_weeks ?? 0) >= CONFIG.UNLOCK.TASK_PHASE_WEEKS ||
  (phase?.effort_level === 3 && (phase?.estimated_weeks ?? 0) >= CONFIG.UNLOCK.TASK_HIGH_EFFORT_WEEKS)
